import React from 'react';
import { Form, TextArea } from 'semantic-ui-react';
import { Label } from './label';
import { FieldError } from './field-error';
import { setupField } from '../utils/form-utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function TextAreaField(props: any) {
  const { handleBlur, handleChange, field, error } = setupField(props);
  return (
    <Form.Field inline error={error}>
      <Label>{props.label}</Label>
      <TextArea autoHeight rows={5} {...field} value={field.value || ''} onChange={handleChange} onBlur={handleBlur} />
      <FieldError {...props}></FieldError>
    </Form.Field>
  );
}
